import React from 'react';

const useFormIndex = () => {
  const [tabsState, setTabsState] = React.useState({ flags: [false] });
  const openTab = (index: number) => {
    tabsState.flags[index] = !tabsState.flags[index];
    setTabsState({ ...tabsState });
  };
  const getShow = (index: number) => tabsState.flags[index];
  const openNext = (next: number) => {
    const nextState = getShow(next);
    openTab(next - 1);
    if (!nextState) openTab(next);
  };
  const getProps = (index: number) => ({
    show: getShow(index),
    setShow: () => openTab(index),
    index: index + 1
  });
  const props1 = {
    ...getProps(0),
    title: 'Mis datos'
  };
  const props2 = {
    ...getProps(1),
    title: 'Mi familia'
  };
  const props3 = {
    ...getProps(2),
    title: 'Ingresos'
  };
  const props4 = {
    ...getProps(3),
    title: 'Egresos'
  };
  const props5 = {
    ...getProps(4),
    title: 'Ahorro y deudas'
  };
  const props6 = {
    ...getProps(5),
    title: 'Vivienda'
  };
  const props7 = {
    ...getProps(6),
    title: 'Salud'
  };
  const props8 = {
    ...getProps(7),
    title: 'Información adicional'
  };
  return {
    getShow,
    openTab,
    openNext,
    props: { props1, props2, props3, props4, props5, props6, props7, props8 }
  };
};

export default useFormIndex;
